/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.monetization.rpc.BadgeInAppService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getProductBadgesRpc = {
  serviceName: 'com.hubspot.monetization.rpc.BadgeInAppService',
  rpcName: 'getProductBadges',
  auth: 'app',
  fingerprint: 'eKOIN_r-zs4FARizkW9-h5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};